<template>
<div>

    <div class="header-banner">
    <section class="section header-block">
        <div class="container">
        <h1>Admin</h1>
      </div>
    </section>
    </div>

    <div class="section">

        <div class="container">
            <h2 class="title">Admin menu</h2>

            <ul class="navbar-nav ml-auto">
                <li class="nav-item active" v-for="link in menuitems" :key="link._id">
                    <router-link tag="a" :to = "{name: link.routelink, params: {}}" class="nav-link">{{ link.name }}</router-link>
                </li>
            </ul>
            
        </div>

    </div>

</div>
</template>

<style scoped>
/* .headline{
    margin-top: 1em;
    display: flex;
    img {
      height: 80px;
      width: 80px;
      border-radius: 50%;
    }
} */
</style>

<script>
import Api from '@/config/Api'
import { mapState } from 'vuex'

//import ProductGroupCards from '../cards/ProductGroupCards';
//import ProductCards from '../cards/ProductCards';

export default {
    name: 'admin',
    data() {
        return {
            menuitems: [
                {
                    _id: 0,
                    name: "Plays",
                    routelink: "admin-plays"
                },
                {
                    _id: 1,
                    name: "Blogs",
                    routelink: "admin-blogs"
                },
                /* {
                    _id: 2,
                    name: "Cast members",
                    routelink: "admin-castmembers"
                }, */
                {
                    _id: 3,
                    name: "About",
                    routelink: "admin-about"
                },
                {
                    _id: 4,
                    name: "Contact us",
                    routelink: "admin-contact"
                },
                {
                    _id: 5,
                    name: "Combinations",
                    routelink: "admin-combinations"
                },
                {
                    _id: 6,
                    name: "Hero images displayed on Homepage",
                    routelink: "admin-heroimages"
                },
            ],
            /* categories: [] */
        }
    },
    components: {
        //ProductGroupCards,
        //ProductCards
    },
    computed: {
        ...mapState({profile: state => state.user.profile}),
    },
    created() {
        /* Api().get('/api/user/productGroupsAndProducts')
        .then(response => {
            this.myProductGroups = response.data.productGroups;
            this.myProducts = response.data.products;
        }); */
    },
    metaInfo: {
      title: "Admin",
      // titleTemplate: null // override the parent template and just use the above title only
      
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/accounts/Admin.vue